import { useState, useEffect } from 'react';

const DARK_MODE_KEY = 'darkMode';

export const useDarkMode = () => {
  const [darkMode, setDarkMode] = useState<boolean>(false);

  useEffect(() => {
    const isDark = localStorage.getItem(DARK_MODE_KEY) === 'true';
    setDarkMode(isDark);
    document.documentElement.classList.toggle('dark', isDark);
  }, []);

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem(DARK_MODE_KEY, newDarkMode.toString());
    document.documentElement.classList.toggle('dark', newDarkMode);
  };

  return { darkMode, toggleDarkMode };
};